// extracted by mini-css-extract-plugin
export default {"root":"RootLayout_root__Q9u4r","logo":"RootLayout_logo__2i5xt","mainCont":"RootLayout_mainCont__Figuc"};